import { render, staticRenderFns } from "./WorkerAssignments.vue?vue&type=template&id=3d0ecbd7&scoped=true&"
import script from "./WorkerAssignments.vue?vue&type=script&lang=js&"
export * from "./WorkerAssignments.vue?vue&type=script&lang=js&"
import style0 from "./WorkerAssignments.vue?vue&type=style&index=0&id=3d0ecbd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ecbd7",
  null
  
)

export default component.exports